import { EvaluationTypes } from './validatorService';
/**
 * Transforms validation options to a better to work with format on the logic side.
 * Two different formats due to ease of configuration
 * @param schema AdaptorValidationOptions - The validation options to be transformed
 */
export const transformValidationSchema = (schema) => {
    const newSchema = {
        eager: {},
        lazy: {},
        allRules: {},
    };
    // Creating a deep copy of schema and working off of that so schema isn't directly effected by any data manipulation
    const copySchema = JSON.parse(JSON.stringify(schema));
    // Loop though all of the ruleSets set on the schema (Can contain mutiple validation options for different elements)
    copySchema.forEach(ruleSet => {
        // Loops through all of the rules on a specific element
        ruleSet.rules.forEach(rule => {
            // Determines if the rule is an eager or lazy evalutation rule
            const ruleType = rule.eager === true ? EvaluationTypes.eager : EvaluationTypes.lazy;
            // Assigns the rule to its respected option inside of the newSchema
            const evaluationRuleType = newSchema[ruleType];
            // If rule.eager was set, remove it since the newSchema seperates out eager and lazy ruleSets
            if (rule.eager) {
                delete rule.eager; // eslint-disable-line no-param-reassign
            }
            // If the element to evaluate doesn't currently exist, create a new entry for it
            // Else, There are already rules set on this element id, add the new rule to the existing array.
            if (!evaluationRuleType[ruleSet.id]) {
                evaluationRuleType[ruleSet.id] = [rule];
            }
            else {
                evaluationRuleType[ruleSet.id] = [...evaluationRuleType[ruleSet.id], rule];
            }
            // Does the same logic as above but adds rule to the all rules evalutionType
            if (!newSchema[EvaluationTypes.allRules][ruleSet.id]) {
                newSchema[EvaluationTypes.allRules][ruleSet.id] = [rule];
                return;
            }
            newSchema[EvaluationTypes.allRules][ruleSet.id] = [...newSchema[EvaluationTypes.allRules][ruleSet.id], rule];
        });
    });
    return newSchema;
};
